import get from 'lodash/get';
import find from 'lodash/find';
import { getAppType, getPathParam } from '@vmos2/core';

export const StockStatus = {
  ON: 'on',
  OFF: 'off',
  OFF_TODAY: 'off-today',
  DAILY: 'daily'
}

export const getStockStatus = (stores, quantityStockStatus, isFutureDayOrdering = false, ignoreFutureDayOrdering = false) => {
  const appType = getAppType();
  const currentStoreId = getPathParam('store');
  const store = find(stores, ({ extStoreUUID }) => extStoreUUID === currentStoreId);

  const type = get(store, `appIsSoldout.${appType}`, StockStatus.ON);
  const status = type === StockStatus.OFF_TODAY && isFutureDayOrdering ? StockStatus.ON : type;
  const quantity = quantityStockStatus === StockStatus.OFF_TODAY && ignoreFutureDayOrdering ? StockStatus.ON : quantityStockStatus;
  const soldOutType = status === StockStatus.ON ? quantity : type;
  const appIsSoldOut = soldOutType === StockStatus.OFF || soldOutType === StockStatus.OFF_TODAY;

  return { soldOutType, appIsSoldOut };
};
